import React from "react"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { FlatButton, Dialog, TextField } from "material-ui"
import PasswordField from "../../../components/common/PasswordField"

interface IProps {
    open: boolean
    savePassword(password: string): void
    close(): void
}
interface IState {
    password: string
    confirmPassword: string
    passwordErrorText: string
    confirmPasswordErrorText: string
    passwordVerified: boolean
}

export default class SetPasswordDialog extends React.Component<IProps, IState> {
    private clickedSave: boolean
    constructor(props: IProps) {
        super(props)
        this.state = {
            password: "",
            confirmPassword: "",
            passwordErrorText: "",
            confirmPasswordErrorText: "",
            passwordVerified: false
        }
        this.clickedSave = false
        autobind(this)
    }

    savePassword() {
        this.clickedSave = true
        if (this.checkValidate()) {
            this.props.savePassword(this.state.password)
        }
    }

    checkValidate() {
        let isValidate = true
        if (!this.state.password) {
            this.setState({ passwordErrorText: strings.Password_required })
            isValidate = false
        } else {
            this.setState({ passwordErrorText: "" })
            if (!this.state.passwordVerified) {
                isValidate = false
            }
        }

        if (!this.state.confirmPassword) {
            this.setState({
                confirmPasswordErrorText: strings.Password_Confirm_Required
            })
            isValidate = false
        } else {
            this.setState({ confirmPasswordErrorText: "" })
        }

        if (this.state.password && this.state.confirmPassword && this.state.password !== this.state.confirmPassword) {
            this.setState({ confirmPasswordErrorText: strings.Passwords_must_match })
            isValidate = false
        }
        return isValidate
    }

    changePassword(e) {
        this.setState({ password: e.target.value }, () =>
            this.clickedSave &&
            this.checkValidate()
        )
    }

    changeConfirmPassword(e) {
        this.setState({ confirmPassword: e.target.value }, () =>
            this.clickedSave &&
            this.checkValidate()
        )
    }

    render() {
        const actions = [<FlatButton label={strings.Cancel} secondary={true} onClick={this.props.close} />, <FlatButton label={strings.Save} primary={true} onClick={this.savePassword} />]
        return (
            <Dialog title={strings.Set_Password} actions={actions} modal open={this.props.open} onRequestClose={this.props.close}>
                <form id="SetPasswordForEmployeeSelfService">
                    <PasswordField
                        password={this.state.password}
                        errorPassword={this.state.passwordErrorText}
                        handleChange={(password, passwordVerified) => this.setState({ password, passwordVerified }, () => this.clickedSave && this.checkValidate())}
                        handleSave={(password, passwordVerified) => this.setState({ password, passwordVerified }, () => this.clickedSave && this.checkValidate())}
                    />
                    <TextField
                        floatingLabelText={strings.Password_Confirmation}
                        value={this.state.confirmPassword}
                        onChange={this.changeConfirmPassword}
                        type="password"
                        errorText={this.state.confirmPasswordErrorText}
                        style={{ width: "100%" }}
                    />
                </form>
            </Dialog>
        )
    }
}
